export const refundTaxHandler = (totalReturnAmount, returnAmount) => {
  const totalReturnedAmount = totalReturnAmount || 0;
  const returnAmountValue = returnAmount || 0;
  const hasRefundTaxAmount =
    totalReturnedAmount !== 0 &&
    Math.abs(totalReturnedAmount) > Math.abs(returnAmountValue);
  const refundTaxAmount = hasRefundTaxAmount
    ? Math.abs(totalReturnedAmount - returnAmountValue)
    : 0;
  return refundTaxAmount;
};
